export default "__VITE_ASSET__0YIgnFRz__"